import { alpha } from '@mui/material/styles';
import basicTheme from '../basicTheme.js';

const checkboxStyleOverrides = {
    defaultProps: {
        disableRipple: true,
    },
    styleOverrides: {
        root: {
            padding: '2px',
            borderRadius: '2px',
            color: basicTheme.palette.N20.main,
            '&.Mui-checked': {
                color: basicTheme.palette.primary.main,
            },
            '&.MuiCheckbox-indeterminate': {
                color: basicTheme.palette.N20.main,
            },
            '> svg': {
                fontSize: '16px',
            },
            cursor: 'pointer',
            ':hover': {
                color: basicTheme.palette.primary.main,
                backgroundColor: alpha(basicTheme.palette.primary.main, 0.2),
                svg: {
                    '> rect': {
                        fill: basicTheme.palette.primary.main,
                    },
                    '> path': {
                        fill: basicTheme.palette.primary.main,
                    },
                },
            },
            '&.Mui-disabled': {
                color: basicTheme.palette.N30.main,
                cursor: 'not-allowed',
                pointerEvents: 'all !important',
                '> svg': {
                    fill: basicTheme.palette.N30.main,
                    '> rect': {
                        fill: basicTheme.palette.N30.main,
                    },
                    '> path': {
                        fill: basicTheme.palette.N30.main,
                    },
                },
                '&:hover': {
                    color: basicTheme.palette.N30.main,
                    backgroundColor: 'transparent',
                },
            },
        },
    },
};

export { checkboxStyleOverrides as default };
//# sourceMappingURL=MuiCheckbox.js.map
